import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ZipCodesState = {}

export const ZipCodesActions = {
  lookupZipcode: async (_, { zipcode }) => {
    return axiosRequest.
      get(`/zipcodes/${zipcode}`).
      then(({ data }) => data.zipcode).
      catch(handleError)
  },
}

export const ZipCodesMutations = {}

export const ZipCodesGetters = {}
